import { BackendApi } from "./HttpBaseService";

const ObtenerReportesPendientes = async () => {
  return await BackendApi.get(`Moderacion/Reportes`);
};

const IgnorarReporte = async id => {
  return await BackendApi.put(`Moderacion/Reportes/${id}/Ignorar`);
};

const AdvertirUsuario = async (id, mensaje) => {
  return await BackendApi.put(
    `Moderacion/Reportes/${id}/Advertir?mensaje=${encodeURIComponent(mensaje)}`
  );
};

const EliminarMensajeReportado = async id => {
  return await BackendApi.put(`Moderacion/Reportes/${id}/EliminarMensaje`);
};

const ExpulsarDePenca = async id => {
  return await BackendApi.put(`Moderacion/Reportes/${id}/Expulsar`);
};

// ── M0-12 / BKW-O0-11: bandeja unificada (chat + reseñas, respuestas, grupos
// y perfiles), suspensión, silenciar en el chat y términos filtrados ──

const ObtenerBandejaModeracion = async () => {
  return await BackendApi.get(`Moderacion/Bandeja`);
};

// accion: Ignorar | Ocultar | Eliminar | RestablecerNombre | QuitarImagen
const ResolverReporteContenido = async (id, accion) => {
  return await BackendApi.put(`Moderacion/Contenido/${id}/${accion}`);
};

// origen: "mensaje" | "contenido"; dias = 0 → indefinida
const SuspenderAutorReporte = async (origen, id, dias, motivo) => {
  return await BackendApi.put(
    `Moderacion/Suspender/${origen}/${id}?dias=${dias}`,
    { motivo }
  );
};

const SilenciarEnChat = async id => {
  return await BackendApi.put(`Moderacion/Reportes/${id}/Silenciar`);
};

// Revisión G0-E, P3: sanciones vigentes y cómo revertirlas.
const ObtenerSancionesActivas = async () => {
  return await BackendApi.get(`Moderacion/Sanciones`);
};

const LevantarSuspension = async usuarioId => {
  return await BackendApi.put(`Moderacion/Usuarios/${usuarioId}/LevantarSuspension`);
};

const QuitarSilencio = async (pencaId, usuarioId) => {
  return await BackendApi.put(
    `Moderacion/Pencas/${pencaId}/Usuarios/${usuarioId}/QuitarSilencio`
  );
};

// P7: imagen quitada, desde el contenedor privado de evidencia (con token).
const DescargarEvidencia = async reporteId => {
  return await BackendApi.get(`Moderacion/Contenido/${reporteId}/Evidencia`, {
    responseType: "blob"
  });
};

const ObtenerTerminosFiltrados = async () => {
  return await BackendApi.get(`Moderacion/Terminos`);
};

const AgregarTerminoFiltrado = async termino => {
  return await BackendApi.post(`Moderacion/Terminos`, { termino });
};

const EliminarTerminoFiltrado = async id => {
  return await BackendApi.delete(`Moderacion/Terminos/${id}`);
};

const ModeracionService = {
  ObtenerReportesPendientes,
  IgnorarReporte,
  AdvertirUsuario,
  EliminarMensajeReportado,
  ExpulsarDePenca,
  ObtenerBandejaModeracion,
  ResolverReporteContenido,
  SuspenderAutorReporte,
  SilenciarEnChat,
  ObtenerTerminosFiltrados,
  AgregarTerminoFiltrado,
  EliminarTerminoFiltrado,
  ObtenerSancionesActivas,
  LevantarSuspension,
  QuitarSilencio,
  DescargarEvidencia
};

export default ModeracionService;
